import { ColumnState } from 'ag-grid-community';

export const mapBEGridSettings = (items: ColumnState[]) =>
  items.map(({ colId, width, pinned, hide }) => ({
    colId,
    width,
    pinned,
    hide,
  }));
